<template>
  <div class="error-layout">
    <div class="container">
      <div class="error__page">
        <div class="error__head">
          <h1 class="error__title">CleanWeb-MAP</h1>
          <p class="error__sub-title">
            The e-Platform for Managed Access Programmes
          </p>
        </div>
        <div class="error__body"><router-view /></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoyoutError",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.error {
  &-layout {
    height: 100%;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0;
    background: #e2e2e2;
  }
  &__head {
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    margin-bottom: 20px;
    padding: 5px 0 5px;
    text-align: center;
  }
  &__title {
    color: #195ca9;
    font-size: 40px;
    line-height: 1.3;
  }
  &__sub-title {
    font-size: 16px;
    color: #1d2226;
  }
}
</style>
